import React, {useEffect, useState} from 'react';
import Modal from "../../../component/Global/Modal";
import ReusableDiv from 'src/support/ReusableDiv';
import {useUserStore} from "../../../hooks/admin/user";
import UserSearchAcctList from '../userManagement/UserSearchAcctList';
import UserSearchAcct from '../userManagement/UserSearchAcct';
import {useDOMAttachToSystemStore} from 'src/hooks/domAttachToSystem';
import useReduxState from 'src/hooks/useReduxState';
import AlertContentWithFlag from 'src/pages/Checkout/AlertContentWithFlag';
import AdminAccountFilterSelection from '../AdminAccountFilterSelection';
import {useAdminAccountFilterStore} from 'src/hooks/admin/adminAccountFilter';
import {Tooltip} from 'src/component/Tooltip';

const SponsorUserAcct = (props) => {
  const [{latest_system_notification_data}, {}, {}] = useDOMAttachToSystemStore();
  //const [status, SetStatus] = useState(false);
  const [{userSearchAcctPopupStatus, selectedAccounts}, {}, {
    update_user_acct_sponsorship,
    set_user_search_acct_popup_status,
    set_selected_accounts
  }] = useUserStore();
  const [{filter_list}, {}, {clear_all_filter, set_filter_list}] = useAdminAccountFilterStore();
  const [errAlert, setErrAlert] = useReduxState("", 'setErrAlert');
  const [disableSponsorBtn, setDisableSponsorBtn] = useState(true);
  const [sponsorBtnTooltip, setSponsorBtnTooltip] = useState('Please select accounts to sponsor');
  const [refreshGrid, setRefreshGrid] = useReduxState(false, 'setRefreshGrid');
  const [errAlertType, setErrAlertType] = useReduxState("", "setErrAlertType");
  const [errMessage, setErrMessage] = useState('');
  const [userListErrAlert, setUserListErrAlert] = useReduxState("", "setUserListErrAlert");
  const [isSponsorRoleSelect, setIsSponsorRoleSelect] = useReduxState(false, 'setIsSponsorRoleSelect');
  
  useEffect(() => {
    set_user_search_acct_popup_status(true)
  }, []);

  const onHide = () => {
    clear_all_filter()
    set_user_search_acct_popup_status(false)
    set_selected_accounts([]);
    if(isSponsorRoleSelect)
      {
        setIsSponsorRoleSelect(false);
      }
  };

  useEffect(() => {
    setSponsorBtnTooltip('')
    setDisableSponsorBtn(false);
    if (!selectedAccounts || selectedAccounts.length === 0) {
      setDisableSponsorBtn(true);
      return;
    }
    for (let i = 0; i < selectedAccounts.length; i++) {
      if (!(selectedAccounts[i].Role && selectedAccounts[i].Role.length > 0)) {
        setSponsorBtnTooltip('Please select a role for the accounts you want to sponsor.');
        setDisableSponsorBtn(true);
        return
      }
    }
  }, [selectedAccounts])
  const onSubmit = async () => {
    const accountList = selectedAccounts.map(v => {
      return {
        accountNumber: v.AccountNumber,
        speedboat: v.Speedboat,
        salesOrg: v.SalesOrg,
        roleId: v.Role,
        userId: props.data.userId
      }
    })
    const res = await update_user_acct_sponsorship({accountList});
    if (res.isSuccessFull) {
      setErrMessage('');
      setUserListErrAlert(res.data, 'success', 'userAcct');
      setErrAlertType('success');
      setRefreshGrid(true);
      onHide();
    } else {
      setErrAlert(res.message || 'Something went wrong', 'danger', 'search')
    }
  };

  return (
    <>
      <Modal show={userSearchAcctPopupStatus} onHide={() => {
        onHide()
      }}>
        <div className="avnet-modal modal-1250" id='sponsoraccount'>
          <div className="avnet-modal-inner">
            <button type="button" className="close py-3" data-dismiss="modal"
                    onClick={onHide}>×
            </button>
            {ReusableDiv.PopupTitle("Sponsor to an Account")}
            <div className="modal-body sponsor-account-popup">
              <div className='px-3 alert-section'>
                {errAlert &&
                  <AlertContentWithFlag message={errAlert} type="danger" isDisplay={false} isDisplayIcon={true}/>
                }
              </div>
              <UserSearchAcct/>
              <AdminAccountFilterSelection/>
              <UserSearchAcctList userData={props.data}/>
            </div>
            <div className="modal-footer d-flex justify-content-center">
              <button type="button" className="bs5 btn btn-secondary"
                      onClick={onHide}>Cancel
              </button>

              {sponsorBtnTooltip ? <Tooltip
                position={'top center'}
                opener={() => (<div style={{
                  marginLeft: '15px'
                }}>
                  <button type="button" disabled={disableSponsorBtn} className="bs5 btn btn-primary"
                          onClick={onSubmit}> Sponsor
                  </button>
                </div>)}
                content={() => sponsorBtnTooltip}
              /> : <button type="button" disabled={disableSponsorBtn} className="bs5 btn btn-primary"
                           onClick={onSubmit}> Sponsor</button>}
            </div>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default SponsorUserAcct;